export default "__VITE_ASSET__DTTSac8w__"